/* eslint-disable */
import { find, indexOf } from 'lodash'

export default  async el => { 
  let sizeSelected, sizeSelection, sizeSecondOption
  const sizeContainer = el.querySelector('.js-size_quick-add') // Size Option Selector
  let colorSelected, colorSelection, colorSecondOption
  const colorContainer = el.querySelector('.js-colors_quick-add') //Color Option Selector 
  let finishSelected, finishSelection, finishSecondOption
  const finishContainer= el.querySelector('.js-finish-colors_quick-add') //Finish Color Option Selector 
  let materialSelected, materialSelection,materialSecondOption
  const materialContainer= el.querySelector('.js-material-colors_quick-add') //Material Option Selector 
  let densitySelected, densitySelection, densitySecondOption
  const densityContainer = el.querySelector('.js-density_quick-add') // Density Option Selector
  let scentSelected, scentSelection, scentSecondOption
  const scentContainer= el.querySelector('.js-scent_quick-add') //Scent Option Selector 
  let current_variant, current_variant_price, activeVariant, $currentActiveSelection, options, container, currentImageSrc, originalImageSrc;
  const productHandleCheck = $(el).find('.js-product-card a:first').attr('href')
  const productHandle = productHandleCheck ? $(el).find('.js-product-card a:first').attr('href').split("/products/")[1].split("?")[0] : null
  let productData;
  let variants;
  let optionTypes = [];
  // MITCH REFACTOR (DONE) - PULLED VARIANT DATA FROM productData AND REMOVED FROM LIQUID RENDER (.js-card-variants) TO LIGHTEN SERVER LOAD
  //NOTE: "price" and "weight" come in differently in this JSON request than liquid request - "price" is parsed for use here (by removing " / 100 "), but double check formats if need for "weight"
  // const variants = el.querySelector('.js-card-variants') && JSON.parse(el.querySelector('.js-card-variants').getAttribute('data-variants'))
  if (productHandle != null) {
    await $.getJSON(`https://snowehome.com/products/${productHandle}.json`, (data)=>{
      variants = data.product.variants
      productData = data 
      productData.product.options.forEach((option) => {
        optionTypes.push(option.name)
      })
    }).fail((error)=>console.log('error: ',error))
  }
  const rlImage = el.querySelector('.js-rl-image')
  const clpSetImage = el.querySelector('.js-clp-set')
  const addToCart = el.querySelector('.js-add-to-cart') //add to cart button
  // MITCH REFACTOR (DONE) - PULLED VARIANT DATA FROM productData AND REMOVED FROM LIQUID RENDER (.js-card-variants) TO LIGHTEN SERVER LOAD
  // const optionTypes = el.querySelector('.js-card-options') && JSON.parse(el.querySelector('.js-card-options').getAttribute('data-options'))
  const swatches = el.querySelectorAll('.js-swatches a')
  const errorHandler = el.querySelector('.js-error-handler')
  const optionsSelector = el.querySelector('.js-options-container_quick-add') // All Options Container
  rlImage ? el.classList.add('rl-image') : null
  clpSetImage ? el.classList.add('coll-set-clp') : null //Sets class to make image double wide
  const variantAvailability = el.querySelectorAll('.js-product-card-variant-option')
  const variantAvailabilityObj = {}
  for (let variant of variantAvailability) {
    variantAvailabilityObj[variant.value] = {
      available: variant.dataset.variantAvailable,
      text: variant.text, 
      name: variant.dataset.variantName,
      backorder: variant.dataset.variantBackorder, 
      preorder: variant.dataset.variantPreorder, 
      soldout: variant.dataset.variantSoldout, 
      waitlist: variant.dataset.variantWaitlist
    };
  }
  const onlyUnique = (value, index, self) => self.indexOf(value) === index

  //Defines the function used to build and return the HTML for each quick add selection container (i.e. Size with all of it's options, or Color witih all of it's swatches)
  const buildOptions = (variants, optionTypes, index) => {
    let optionArray = []
    index === 0 && variants.forEach((variant) => optionArray.push(variant.option1))
    index === 1 && variants.forEach((variant) => optionArray.push(variant.option2))
    index === 2 && variants.forEach((variant) => optionArray.push(variant.option3))
    const unique = optionArray.filter(onlyUnique)
    let quickAddOptionHTML;

    if (optionTypes[index] === 'Color' || optionTypes[index] === 'Material' || optionTypes[index] === 'Finish') {
      quickAddOptionHTML = `
      <div class='f fw jcb aic x'>
        <div class='al pr05 py05 pl0'>
          <h5 class='option-name m0 p0 ls-n fw4 cng'>Select ${optionTypes[index]}</h5>
        </div>
        <div class="swatches js-swatches rel z3 lowered-swatches f jcs">

          ${unique.map(name => {
            let colorClass;
            if (name === 'Cream & Charcoal' || name === 'Cream/Charcoal') colorClass = "cream"
            else if (name === 'Charcoal & Cream' || name === 'Charcoal/Cream'|| name === 'Oxidized Walnut' ||  name === 'Walnut - Oxidized') colorClass = 'charcoal'       
            else if (name === 'Grey/Blue' || name === 'Grey & Blue' || name === 'Grey' ) colorClass = 'grey'
            else if (name === 'Slate') colorClass = 'greyblue'
            else if (name === 'Black Satin') colorClass = 'black'
            else if (name === 'Classic Stainless') colorClass = 'stainless'
            else if (name === 'Brushed Gold') colorClass = 'gold'
            else if (name === 'Walnut' ||  name === 'Walnut - Natural') colorClass = 'walnut'
            else colorClass = name.toLowerCase().split(' ')[0] //Same fallback color class setter used on PDPs
            const variant = productData && productData.product.variants.find((variant)=>{
              if(index === 0) return variant.title.split(" / ")[0].includes(`${name}`)
              if (index === 1) return variant.title.split(" / ")[1].includes(`${name}`)
              if (index === 2) return variant.title.split(" / ")[2].includes(`${name}`)
            }) 
            const dataImage = $(el).find(`.swatch[data-variant-id="${variant.id}"]`).data('image')
            let swatchColor = $(el).find(`.product-details .swatch[data-variant-id="${variant.id}"]`).css('background-color') === "rgba(0, 0, 0, 0)" 
            ? 'unset' 
            : `${$(el).find(`.product-details .swatch[data-variant-id="${variant.id}"]`).css('background-color')}!important`

            return `<a class="swatch js-variant-selector quick-add-swatch ${colorClass}" style="background-color:${swatchColor}" data-selected=false data-variant-url="snowehome.com/products/${productHandle}?variant=${variant.id}" data-color-name="${name}" data-variant-id="${variant.id}" data-variant-option="${name}" data-image="${dataImage}" data-image-hover="">
                      <span class="hidden-color-name">${name}</span>
                    </a>`
          }).join('')}

        </div>
      </div>` 
    }
    else {
      let opt_name;
      quickAddOptionHTML = `
          <div class='f fw jcs aic pb1'>
          <div class='x al pl0 pr05 py075'>
            <h5 class='option-name s14 cng m0 p0 fw4 ls-n'>Select ${optionTypes[index]}</h5>
          </div>
            <div class="f jcb x quick-add-options_non-color">
              ${unique.map(name => {
                if(name === 'California King') opt_name = 'CAL KG'
                else if(name === 'Full') opt_name = 'FL'
                else if(name === 'Full/Queen') opt_name = 'FL/QN'
                else if(name === 'Queen') opt_name = 'QN'
                else if(name === 'King') opt_name = 'KG'
                else if(name === 'Standard') opt_name = 'STND'
                else if(name === 'X-Small') opt_name = 'XS'
                else if(name === 'Small') opt_name = 'S'
                else if(name === 'Medium') optionTypes[index] === "Size" ? opt_name = "M" : opt_name = 'Med'
                else if(name === 'Large') opt_name = 'L'
                else opt_name = name
                const variant = productData && productData.product.variants.find((variant)=>{
                  if (index === 0) return variant.title.split(" / ")[0].includes(`${name}`)
                  if (index === 1) return variant.title.split(" / ")[1].includes(`${name}`)
                  if (index === 2) return variant.title.split(" / ")[2].includes(`${name}`)
                }) 
                return `<div class='collection__product_card--variant cg js-variant-selector px05 py075 mr05 cb x f jcc aic ac cng' data-selected=false data-variant-option='${name}'>${opt_name}</div>`
              }).join('')}
            </div>
          </div>`
    }
    return  quickAddOptionHTML
  }

//Defines the function used to add to cart via Ajax call
  const CLPAddToCart =  (variantId, errorHandler, optionsSelector, cb) =>  {
    /* eslint-disable */
    setTimeout(()=>{
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: `id=${variantId}&quantity=1`,
        success: function (data) {
          Cart.prototype.successCLP(data);
          errorHandler.classList.remove('show')
          errorHandler.classList.add('hide')
          standard.showSidePanel();
          data && data.quantity > 0 && $('#cart-toggle').addClass('fill')
          $.getJSON(`https://snowehome.com/products/${productHandle}.json`, productData => {
            productData && productData.product.variants.find(variant => {
              if (variant.id === +variantId) {
                let productTitle = `${productData.product.title} - ${variant.title}`
                let productPrice = variant.price
                quickAddProducts.push({
                  'label': productTitle,
                  'value': productPrice,
                  'QA Product Title': productTitle,
                  'QA Product Price': productPrice,
                  'variantId': variantId
                })
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  'event': 'quickAddToCart',
                  'quickAddProducts': quickAddProducts,
                });
              }
            })
          }).fail((error) => console.log('error: ', error))
          cb()
        },
        error: function (error) {
          console.error(error)
          const response = error.responseJSON.description
          optionsSelector.classList.add('open')
          errorHandler.innerHTML = response
          errorHandler.classList.add('show')
          errorHandler.classList.remove('hide')
          Cart.prototype.errorCLP(error);
        }
      });
      closeAll()
    }, 500)
  }

// Defines function used to close out specific quick add window. FIXME - Refactor: We're mostly using 'closeAll' function to accomplish, so would be good to combine these efforts into one
  const closeCLP = () => {
    // This should close all the things we open below!
    if(colorContainer) {
      colorContainer.classList.remove('open')
      $(colorContainer).empty()
    }
    densityContainer && densityContainer.classList.remove('open')
    optionsSelector && optionsSelector.classList.remove('open')
  }
  
  //Defines function used to close out all open instances of quick add
  const closeAll = (product_card) =>  {
    $(document).find('.quick-add-icon.hide').each((_,hiddenAddIcon)=>{$(hiddenAddIcon).removeClass('hide')}) // unhides qick add icon when closing out of quick add box
    // Close all instances
    const allPicker = document.querySelectorAll('.js-collection-colors.highlight')
    const allDensity = document.querySelectorAll('.js-density_quick-add.open')
    const allOption = document.querySelectorAll('.js-options-container_quick-add.open')
    allPicker.forEach(picker => picker && picker.classList.remove('highlight'))
    allDensity.forEach(density => density && density.classList.remove('open'))
    allOption.forEach(option => option && option.classList.remove('open'))
    $('.js-options-container_quick-add').each((idx,container)=>{
      let $priceHolder = $(container).closest('.js-options-container_quick-add').find('.js-price-update .price-info')
      if($priceHolder.data('product-compare')){
        $(container).closest('.collection__product_card').hasClass('variant-breakout') 
        ? $priceHolder.html(`<span class='strikethrough mr05'>$${$priceHolder.data('variant-compare')}</span> $${Math.round($priceHolder.data('variant-price'))}`)
        : $priceHolder.html(`<span class='strikethrough mr05'>$${$priceHolder.data('product-compare')}</span> $${Math.round($priceHolder.data('product-price'))}`) 
      } else {
        $(container).closest('.collection__product_card').hasClass('variant-breakout') 
        ? $priceHolder.html(`$${$priceHolder.data('variant-price')}`)
        : $priceHolder.html(`$${$priceHolder.data('product-price')}`)
      }
    })
    if(product_card){
      $(product_card).find('.collection__product_card_image img.orig').attr('src', $(product_card).data('original-image'))
      $(product_card).find('.collection__product_card_image img.hover').removeClass('hidden')
    } 
    sizeSelected = false;sizeSelection = null;
    colorSelected = false;colorSelection = null;
    finishSelected = false;finishSelection = null;
    materialSelected = false;materialSelection = null;
    densitySelected = false;densitySelection = null;
    scentSelected = false;scentSelection = null;
    activeVariant = null;
    current_variant = null;
  }


// Defines 'on click' fuction when clicking on a specific swatch/variant option
  const optionOnClick = e => {
    e.preventDefault()
    let option = e.target
    let $option = $(option)
    container = $option.closest('.collection__product_card--options_block')
    let optionType = container.data('option-name')
    options = $option.closest('.collection__product_card--options_block').find('.js-variant-selector')
    let optionTypeIndex = indexOf(optionTypes, optionType)

    //Removes highlighting classes for selected option
    $(container).find('h5.option-name').removeClass('black-text')
    options.each((i, o) => {
      o.classList.remove('active', 'highlight')
      o !== option && $(o).data('selected', false)
    })
    $option.data('selected') === true ? $option.data('selected', false) : $option.data('selected', true) 
    let optionSelection = $(option).data('variant-option')
      if(optionType == 'Color'){colorSelected = false;colorSelection = null} //Clears current selection variables
      else if(optionType == 'Finish'){finishSelected = false;finishSelection = null}
      else if(optionType == 'Material'){materialSelected = false;materialSelection = null}
      else if(optionType == 'Density'){densitySelected = false;densitySelection = null;}
      else if(optionType == 'Size'){sizeSelected = false;sizeSelection = null;}
      else if(optionType == 'Scent'){scentSelected = false;scentSelection = null;}
      setCurrentVariant(container, options[0], optionTypeIndex, $option.data('selected')) //Resets current selection back to default
    
    if($option.data('selected') == true) { //Only set variant if selecting option, not deselecting option
      option.classList.add('active', 'highlight')
     if( optionType === 'Color' || optionType === 'Finish' || optionType === 'Material'){$(container).find('h5.option-name').addClass('black-text')}
      if(optionType == 'Density'){
        densitySelected = true;densitySelection = optionSelection
        setCurrentVariant(container, option, optionTypeIndex, $option.data('selected')) // Sets current_variant variable with this selection
        if (densitySecondOption == "Size" && sizeSelection) setActiveVariant(densitySelection, indexOf(optionTypes, 'Size'), sizeSelection) //Checks if other option has already been made - if so, sets 'activeVariant' variable 
      }
      else if(optionType == 'Size'){
        sizeSelected = true;sizeSelection = optionSelection
        setCurrentVariant(container, option, optionTypeIndex, $option.data('selected'))
        if (sizeSecondOption == "Density" && densitySelection) setActiveVariant(sizeSelection, indexOf(optionTypes, 'Density'), densitySelection) 
        else if (sizeSecondOption == "Color" && colorSelection) setActiveVariant(sizeSelection, indexOf(optionTypes, 'Color'), colorSelection) 
      }
      else if(optionType == 'Color'){
        colorSelected = true;colorSelection = optionSelection
        
        setCurrentVariant(container, option, optionTypeIndex, $option.data('selected'))
        if (colorSecondOption == "Size" && sizeSelection) setActiveVariant(colorSelection, indexOf(optionTypes, 'Size'), sizeSelection)
      }
      else if(optionType == 'Finish'){
        finishSelected = true;finishSelection = optionSelection
        setCurrentVariant(container, option, optionTypeIndex, $option.data('selected'))
        if (finishSecondOption == 'Material' && materialSelection)setActiveVariant(finishSelection, indexOf(optionTypes, 'Material'), materialSelection) 
      }
      else if(optionType == 'Material'){
        materialSelected = true;materialSelection = optionSelection
        setCurrentVariant(container, option, optionTypeIndex, $option.data('selected'))
        if (materialSecondOption == 'Finish' && finishSelection) setActiveVariant(materialSelection, indexOf(optionTypes, 'Finish'), finishSelection) 
      }
      else if(optionType == 'Scent'){
        scentSelected = true;scentSelection = optionSelection
        setCurrentVariant(container, option, optionTypeIndex, $option.data('selected'))
      }
    }
     else {
      $(el).find('.product-link img.orig').attr('src', $(el).data('original-image'))
      $(el).find('.collection__product_card_image img.hover').removeClass('hidden')
     }
     
    if (optionTypes.length === 1) { //If only one option exists, sets activeVariant and adds to cart
        activeVariant = find(variants, { 'option1': optionSelection})
        activeVariant && CLPAddToCart(activeVariant.id, errorHandler, null, closeCLP)
        return false
      }
    else if (el.classList.contains('variant-breakout')) { //If variant is broken out, second option is automatically set (as it's broken out so not selectable) - adds to cart
      CLPAddToCart(current_variant.id, errorHandler, null, closeCLP)
      return false
    }
    activeVariant && CLPAddToCart(activeVariant.id, errorHandler, null, closeCLP)
  } // end optionOnClick


  // Defines function to set information based on selection of 2 of 2 variant options
  const setActiveVariant = (mainOptionSelection, secondOptionIndex, secondOptionSelection) => {
    
    if(secondOptionIndex === 0) activeVariant = find(variants, { 'option1': secondOptionSelection, 'option2': mainOptionSelection })
    else if (secondOptionIndex === 1) activeVariant = find(variants, { 'option1': mainOptionSelection, 'option2': secondOptionSelection })
    if(activeVariant.compare_at_price){
      let activeVariant_discount = Math.round(activeVariant.price)
      $(container).closest('.js-options-container_quick-add').find('.js_quick-add_product-info .js-price-update .price-info').html(`<span class='strikethrough mr05'>$${parseFloat(activeVariant.compare_at_price)}</span>$${parseFloat(activeVariant_discount)}`) // updates price when both selections are made // updates price when both selections are made
    } else {
      $(container).closest('.js-options-container_quick-add').find('.js_quick-add_product-info .js-price-update .price-info').html(`$${parseFloat(activeVariant.price)}`) // updates price when both selections are made
    } 
  }

// Defines function to set information based on initial load/selection of 1 of 2 variant options
  const setCurrentVariant = (container, currentSelection, currentSelectionIndex, selectionMade)=>{

    $(container).closest('.quick-add_inner').find('.js-variant-selector.sold-out').each((idx, node) => { //removes any 'sold out' classes and adds enables onClick for all options
      $(node).removeClass('sold-out')
      let node_events = $._data($(node).get(0), 'events')
      !node_events.click && $(node).on('click', optionOnClick)
  }) 
  
  if(el.classList.contains('variant-breakout')){ // sets current_variant variable if product is broken out by variants - variant_breakout_option represents the automotic choice that product is broken out by (i.e. color for robes)
    let variant_breakout_option = $(el).find(`.js-product-card-variant`).data('breakout-option')
    let breakoutOptionIndex = indexOf(optionTypes, variant_breakout_option)
    // let breakoutOptionValue = $(el).find(`.js-product-card-variant-option`).data('variant-name').split(" / ")[breakoutOptionIndex]
    let breakoutOptionValue = $(el).find(`.js-product-card-variant`).data('product-variant-displayed').split(" / ")[breakoutOptionIndex]

    current_variant = currentSelectionIndex === 0 
      ? find(variants, { 'option1': $(currentSelection).data('variant-option'), 'option2': breakoutOptionValue}) 
      : find(variants, { 'option1': breakoutOptionValue, 'option2': $(currentSelection).data('variant-option')}) 
  }
  else { // sets current_variant variable when only one option has been selected
    current_variant = currentSelectionIndex === 0 
      ? find(variants, { 'option1': $(currentSelection).data('variant-option')}) 
      : find(variants, { 'option2': $(currentSelection).data('variant-option')}) 
  }

  $currentActiveSelection = $(container).closest('.js-options-container_quick-add').find('.js-variant-selector.active');

  if($currentActiveSelection.length && $currentActiveSelection.hasClass('swatch')){     
    currentImageSrc = $(el).find('.product-link img.orig').attr('src') 
    currentImageSrc != $(el).data('original-image') ? $(el).find('.collection__product_card_image img.hover').addClass('hidden') : $(el).find('.collection__product_card_image img.hover').removeClass('hidden')
  }

      selectionMade ? current_variant.default_initial_choice = false :  current_variant.default_initial_choice = true // sets a marker on variant to show if current_variant was selected or is default selection on load
      let inventory_hash = {} //uses data hash tables to reference inventory levels, inventory policy, and superfields sold out information 
      let inventory_policy_hash = {}
      let sf_soldout_hash = {}


      if(selectionMade){ //if one choice is made, check all of the possible second choices inventory levels, inventory policies, and superfields and add 'sold-out' classes and remove onClick if applicable
        variants.forEach((variant,i)=>{

          let variant_option = currentSelectionIndex === 0 
          ? variant.option1
          : variant.option2
          let variant_second_option = currentSelectionIndex === 0 
            ? variant.option2
            : variant.option1 
          if( variant_option === $(currentSelection).data('variant-option')) {
            variant.inventory_quantity <= 0 && variant.inventory_policy != 'continue' && $(container).closest('.js-options-container_quick-add').find(`.js-variant-selector[data-variant-option="${variant_second_option}"]`).addClass('sold-out').off('click')

            //Checks if variant is waitlisted and disables click
            if(variantAvailabilityObj[variant.id].waitlist === "true") {
              $(container).closest('.js-options-container_quick-add').find(`.js-variant-selector[data-variant-option="${variant_second_option}"]`).addClass('sold-out').off('click')
            }


            if($(el).find(`.js-product-card-variant option[value="${variant.id}"]`).data('variant-soldout') == true){ //checks superfields sold out information
              $(container).closest('.js-options-container_quick-add').find(`.js-variant-selector[data-variant-option="${variant_second_option}"]`).addClass('sold-out').off('click')
            }
           }
        })
      }
      else { //if no selection is made, build inventory, inventory policy, and superfields hash tables (which will show if something is sold out across all variants)
        let variant_option_marker = currentSelectionIndex === 0 
        ? variants[0].option1
        : variants[0].option2
        sf_soldout_hash[variant_option_marker] = $(el).find(`.js-product-card-variant option[value="${variants[0].id}"]`).data('variant-soldout')

        variants.forEach((variant,i)=>{
          //builds hash table to check inventory levels
          let variant_option = currentSelectionIndex === 0 
          ? variant.option1
          : variant.option2

          let variant_second_option = currentSelectionIndex === 0 
            ? variant.option2
            : variant.option1 

          inventory_hash[variant_option] 
            ? inventory_hash[variant_option] += variant.inventory_quantity 
            : inventory_hash[variant_option] =  variant.inventory_quantity 
          
            
          // If the inventory policy is already in hash table, check if its set to 'continue' already. If so, no need to change, as it means at least one variant with this option is allowed to be sold.  If not 'continue', adjust element to be new policy. If the inventory policy is not in hash table, create it in table. 
            inventory_policy_hash[variant_option] 
            ? inventory_policy_hash[variant_option] = inventory_policy_hash[variant_option] != 'continue' ? variant.inventory_policy : 'continue'
            : inventory_policy_hash[variant_option] = variant.inventory_policy
            
          // checks superfields sold out information - if not set to false, superfields 'sold out' is set across all variants
          sf_soldout_hash[variant_option] = sf_soldout_hash[variant_option] === false ? false : $(el).find(`.js-product-card-variant option[value="${variant.id}"]`).data('variant-soldout') 
          sf_soldout_hash[variant_second_option] = sf_soldout_hash[variant_second_option] === false ? false : $(el).find(`.js-product-card-variant option[value="${variant.id}"]`).data('variant-soldout') 

          // For quick add with 1 option: Checks variantAvailabilityObj to see if variant is on the waitlist and disables waitlisted option 
          if (productData.product.options.length === 1) {
            if(variantAvailabilityObj[variant.id].waitlist === "true") {
              $(container).closest('.js-options-container_quick-add').find(`.js-variant-selector[data-variant-id="${variant.id}"]`).addClass('sold-out').off('click')
            }
          }

        })
      }

      //checks inventory levels hash table - if all variants with this option are sold out, set 'sold-out' classes and remove onClick
      Object.keys(inventory_hash).forEach(option => {
        let optionNode = $(container).closest('.js-options-container_quick-add').find(`.js-variant-selector[data-variant-option="${option}"]`)
        inventory_hash[option] <= 0  && optionNode.addClass('sold-out-default').off('click')
      })

      //checks inventory policy hash table - if all variants do not allow products to be sold when inventory levels are below 0 AND inventory is below 0 for all variants, set 'sold-out' classes and remove onClick
      Object.keys(inventory_policy_hash).forEach(option => {
        let optionNode = $(container).closest('.js-options-container_quick-add').find(`.js-variant-selector[data-variant-option="${option}"]`)
        if(inventory_policy_hash[option] != 'continue' && inventory_hash[option] <= 0) {
          optionNode.addClass('sold-out-default').off('click') 
        }
        else {
          optionNode.removeClass('sold-out-default')
          let node_events = $._data( optionNode.get(0), 'events')
          !node_events && optionNode.on('click', optionOnClick)
        }  
      })

      Object.keys(sf_soldout_hash).forEach(option => { // when no selection, mark option as sold out if there is no stock of any variant/sku combination
        let optionNode = $(container).closest('.js-options-container_quick-add').find(`.js-variant-selector[data-variant-option="${option}"]`)
        sf_soldout_hash[option] === true  && optionNode.addClass('sold-out-default').off('click')
      })
    if(current_variant.compare_at_price){
      current_variant_price = activeVariant ? parseFloat(activeVariant.compare_at_price) : parseFloat(current_variant.compare_at_price)
      let current_variant_discount = Math.round(current_variant.price)
      $(container).closest('.js-options-container_quick-add').find('.js_quick-add_product-info .js-price-update .price-info').html(`<span class='strikethrough mr05'>$${parseFloat(current_variant_price)}</span>$${parseFloat(current_variant_discount)}`) // updates price when first selection is made // updates price when first selection is made
    } else {
      current_variant_price = activeVariant ? parseFloat(activeVariant.price) : parseFloat(current_variant.price)
      $(container).closest('.js-options-container_quick-add').find('.js_quick-add_product-info .js-price-update .price-info').html(`$${parseFloat(current_variant_price)}`) // updates price when first selection is made
    }
    
  } // end setCurrentVariant

  // Defines function to set information when hovering over second of two variant options
  const setHoverInfo = (container, hoverSelection, hoverType, hoverTypeIndex) => {
    let hover_variant;
    if (!current_variant.default_initial_choice) {  //Collects hovered variant object data if another variant has been selected
      if(hoverTypeIndex === 0) hover_variant = find(variants, { 'option1': $(hoverSelection).data('variant-option'), 'option2': current_variant.option2})
      else if (hoverTypeIndex === 1) hover_variant = find(variants, { 'option1': current_variant.option1, 'option2': $(hoverSelection).data('variant-option')})
    } 
    else { //Collects hovered variant object data if no variant has been selected
      if(hoverTypeIndex === 0) hover_variant = find(variants, { 'option1': $(hoverSelection).data('variant-option')})
      else if (hoverTypeIndex === 1) hover_variant = find(variants, { 'option2': $(hoverSelection).data('variant-option')})  
    }

    if($currentActiveSelection.length){ //Show backorder information if one selection has been made, when user is hovering over second options
      let hover_variant_backorder_date = $(el).find(`.js-product-card-variant option[value="${hover_variant.id}"]`).data('variant-backorder')
      let product_backorder_date = $(el).find(`select.js-product-card-variant`).data('product-backorder')
      if(!$currentActiveSelection.closest(`div[data-option-name="${hoverType}"]`).length){
        hover_variant_backorder_date 
        ? $(container).closest('.js-options-container_quick-add').find('.js_quick-add_backorder-info p').text(`(Preorder for ${hover_variant_backorder_date})`).parent().addClass('x')
        : $(container).closest('.js-options-container_quick-add').find('.js_quick-add_backorder-info p').text(``).parent().removeClass('x')
        if(product_backorder_date){
          $(el).find('.js-product-card-variant').data('product-backorder') && $(el).find('.js_quick-add_backorder-info').addClass('x').find('p').text(`(Preorder for ${$(el).find('.js-product-card-variant').data('product-backorder')})`)
        }
      } //if hover variant has back order date and hovered option type is not the same as current selection (i.e. Size when hovering on Euro)
    } //Show backorder information if no selection has been made, but there is only one option (i.e. just swatches)
    else if(optionTypes.length === 1) {
      let hover_variant_backorder_date = $(el).find(`.js-product-card-variant option[value="${hover_variant.id}"]`).data('variant-backorder')
      hover_variant_backorder_date !== null 
      ? hover_variant_backorder_date && $(container).closest('.js-options-container_quick-add').find('.js_quick-add_backorder-info p').text(`(Preorder for ${hover_variant_backorder_date})`).parent().addClass('x')
      : $(container).closest('.js-options-container_quick-add').find('.js_quick-add_backorder-info p').text(``).parent().removeClass('x')
    } 
    else if (optionTypes.length > 1 && el.classList.contains('variant-breakout')) {
      //Find breakout option & value
      let variant_breakout_option = $(el).find(`.js-product-card-variant`).data('breakout-option')
      let breakoutOptionIndex = indexOf(optionTypes, variant_breakout_option)
      let breakoutOptionValue = $(el).find(`.js-product-card-variant`).data('product-variant-displayed').split(" / ")[breakoutOptionIndex]
      //find hover/second option value
      let secondOptionValue = breakoutOptionIndex === 0 ? hover_variant.option2 : hover_variant.option1
      //find correct variant based on breakout value & hover/second option value
      let breakoutHoverVariant = breakoutOptionIndex === 0 
        ? find(variants, { 'option1': breakoutOptionValue, 'option2': secondOptionValue}) 
        : find(variants, { 'option1': secondOptionValue, 'option2': breakoutOptionValue}) 

      // Find backorder date if it exists
      let hover_variant_backorder_date = $(el).find(`.js-product-card-variant option[value="${breakoutHoverVariant.id}"]`).data('variant-backorder')
      // if backorder date make it display on screen
      hover_variant_backorder_date !== null 
      ? hover_variant_backorder_date && $(container).closest('.js-options-container_quick-add').find('.js_quick-add_backorder-info p').text(`(Preorder for ${hover_variant_backorder_date})`).parent().addClass('x')
      : $(container).closest('.js-options-container_quick-add').find('.js_quick-add_backorder-info p').text(``).parent().removeClass('x')
    }


    //Show variant price when hovering over different variant options
    if(hover_variant.compare_at_price){
      let hover_variant_discount = Math.round(hover_variant.price)
      $(container).closest('.js-options-container_quick-add').find('.js_quick-add_product-info .js-price-update .price-info').html(`<span class='strikethrough mr05'>$${parseFloat(hover_variant.compare_at_price)}</span>$${parseFloat(hover_variant_discount)}`)
    } else {
      $(container).closest('.js-options-container_quick-add').find('.js_quick-add_product-info .js-price-update .price-info').html(`$${parseFloat(hover_variant.price)}`)
    }
    return hover_variant
  } // end setHoverInfo



  //Defines function to set hover logic and on initial current variant (via setCurrentVariant - which will ultimately add the optionOnClick function. FIXME REFACTOR - it would be nice to add the optionOnClick function a little higher up the funnel)
  const setOnClickAndHover = (container, option, idx, optionType) =>{
    let optionTypeIndex = optionTypes.indexOf(optionType)
    let $option = $(option)
    idx === 0 && setCurrentVariant(container, option, optionTypeIndex, $option.data('selected')) //on intial load, set current_variant to be the first avaiable variant option
    
    //Hover logic
    if($option.hasClass('swatch')){ //Hover logic for swatches
      $option.mouseenter(()=> {
        !$option.hasClass('sold-out') && $(el).find('.product-link img.orig').attr('src', $option.data('image')) // change image on hover
        if(!$option.hasClass('sold-out')){
          $option.data('variant-option') != $(container).closest('.js-options-container_quick-add').find('.js-variant-selector.active').data('variant-option')
           ? $(container).find('h5.option-name').text($option.data('variant-option')).removeClass('black-text') //if hovered option is not sold and doesn't equal what is already selected, change Select Color to option name and remove black font
           : $(container).find('h5.option-name').text($option.data('variant-option')).addClass('black-text') //if hovered option is not sold and doesn't equal what is already selected, change Select Color to option name and remove black font
        } 

        setHoverInfo(container, option, optionType, optionTypeIndex);               
      })
      $option.mouseleave(()=> {
        $(window).on('mousemove', (e)=>{
          if(!$(e.target).hasClass('swatch') && !$(e.target).hasClass('swatches')) {
            $currentActiveSelection.length ? $(el).find('.product-link img.orig').attr('src', currentImageSrc) : $(el).find('.product-link img.orig').attr('src', originalImageSrc)  // change image back to selected variant image
            if(current_variant != null){
              if(current_variant.compare_at_price){
                let current_variant_discount = Math.round(current_variant.price)
                $(container).closest('.js-options-container_quick-add').find('.js_quick-add_product-info .js-price-update .price-info').html(`<span class='strikethrough mr05'>$${Math.round(current_variant.compare_at_price)}</span>$${parseFloat(current_variant_discount)}`) //set price back to current selection price 
              } else {
                $(container).closest('.js-options-container_quick-add').find('.js_quick-add_product-info .js-price-update .price-info').html(`$${parseFloat(current_variant_price)}`) //set price back to current selection price          
              }
            }
            if(!$(el).find(`select.js-product-card-variant`).data('product-backorder')){
              if( $(container).closest('.js-options-container_quick-add').find('.js-variant-selector.active').length || optionTypes.length === 1){
                $(container).closest('.js-options-container_quick-add').find('.js_quick-add_backorder-info p').text(``).parent().removeClass('x') 
                //remove backorder info if it doesn't exist on a product level and (there is another selected option or there is only one option)
              }
            }
            $(window).off('mousemove')
          } 
        })
       
        let swatchSelected;
        if(optionType === "Color") swatchSelected = colorSelected
        if(optionType === "Finish") swatchSelected = finishSelected
        if(optionType === "Material") swatchSelected = materialSelected

        if(!swatchSelected ){
           $(window).on('mousemove', (e)=>{
             if(!$(e.target).hasClass('swatch') && !$(e.target).hasClass('swatches')) {
              $(container).find('h5.option-name').text(`Select ${$(container).data('option-name')}`)
               $(window).off('mousemove')
             } 
           })
        }
        else {
          $(window).on('mousemove', (e)=>{
            if(!$(e.target).hasClass('swatch') && !$(e.target).hasClass('swatches')) {
              $(container).find('h5.option-name').text($(container).closest('.js-options-container_quick-add').find('.js-variant-selector.active').data('variant-option')).addClass('black-text') // if swatch is not selected, set text back to 'Select Color/Finish/Material' otherwise set to selected swatch and make text black
              $(window).off('mousemove')
            } 
          })
        }
      })
    }
    else { //Hover logic for non color swatches
      $option.mouseenter(()=>{
        setHoverInfo(container, option, optionType, optionTypeIndex)
      })
      $option.mouseleave(()=>{
        $(window).on('mousemove', (e)=>{
          if(!$(e.target).hasClass('js-variant-selector') && !$(e.target).hasClass('quick-add-options_non-color') ){
            if(current_variant != null){
              if(current_variant.compare_at_price){
                let current_variant_discount = Math.round(current_variant.price)
                $(container).closest('.js-options-container_quick-add').find('.js_quick-add_product-info .js-price-update .price-info').html(`<span class='strikethrough mr05'>$${Math.round(current_variant.compare_at_price)}</span>$${parseFloat(current_variant_discount)}`)//set price back to current_variant price
              } else {
                $(container).closest('.js-options-container_quick-add').find('.js_quick-add_product-info .js-price-update .price-info').html(`$${parseFloat(current_variant_price)}`)//set price back to current_variant price
              }
            }
            if(!$(el).find(`select.js-product-card-variant`).data('product-backorder')){
              if( $(container).closest('.js-options-container_quick-add').find('.js-variant-selector.active').length || optionTypes.length === 1){
                $(container).closest('.js-options-container_quick-add').find('.js_quick-add_backorder-info p').text(``).parent().removeClass('x') 
                //remove backorder info if it doesn't exist on a product level and (there is another selected option or there is only one option)
              }
            }
          } 
        })
      })
    }
  } // end quickAdd function 

  $(document).ready(()=>{ //Prevents redirect to PDP when clicking on quick add icon
    $(el).find('.js-product-card a:first').click(e => {
      if($(e.target).hasClass('quick-add-icon') || $(e.target).closest('.js-options-container_quick-add').length)  e.preventDefault()
    })
  })
  $(window).resize(() => window.matchMedia("(max-width: 767px)").matches && closeAll($(document).find('.collection__product_card--options.open').closest('.collection__product_card').get(0)))   //Closes all quick add instances if window screen goes mobile
  $(document).on('click', e => { //Close all open quick add boxes if not clicking on quick icon or inside quick add selection
    !$(e.target).closest('.js-options-container_quick-add').length && !$(e.target).hasClass('quick-add-icon') && closeAll( $(document).find('.collection__product_card--options.open').closest('.collection__product_card').get(0))
    e.stopImmediatePropagation()
  })

  if(!el.classList.contains('no-quick-add')) { // Unless element has class 'no-quick-add' which is added through superfields selection
    addToCart && addToCart.addEventListener('click', (e) => { // Adds onclick to addToCart
      //Close any open quick add selections
      let product_card = $(e.target).closest('.collection__product_card').get(0)
      let $quickAddContainer = $(e.target).closest('.js-product-card').find('a:first .js-options-container_quick-add');
      $(window).on('scroll.quick-add', () => {
        //if quick add is scrolled out of view, close box
       if( window.pageYOffset >$quickAddContainer.offset().top || window.pageYOffset + $(window).height() < $quickAddContainer.offset().top){
        closeAll(product_card)
        sizeSelected = false;sizeSelection = null;
        colorSelected = false;colorSelection = null;
        finishSelected = false;finishSelection = null;
        materialSelected = false;materialSelection = null;
        densitySelected = false;densitySelection = null;
        scentSelected = false;scentSelection = null;
        $(window).off('scroll.quick-add')
       }
      })

      $(el).attr('data-original-image', $(el).find('.product-link img.orig').attr('src'))
      $(document).find('.js-options-container_quick-add.open').length && closeAll(product_card)
      sizeSelected = false;sizeSelection = null;
      colorSelected = false;colorSelection = null;
      finishSelected = false;finishSelection = null;
      materialSelected = false;materialSelection = null;
      densitySelected = false;densitySelection = null;
      scentSelected = false;scentSelection = null;
      originalImageSrc = $(el).find('.product-link img.orig').attr('src')
      
      currentImageSrc = $(el).find('.product-link img.orig').attr('src')
      optionsSelector.classList.add('open')
      $(e.target).addClass('hide') // hides quick after pressing it
      $(el).find('.js-product-card-variant').data('product-backorder') && $(el).find('.js_quick-add_backorder-info').addClass('x').find('p').text(`(Preorder for ${$(el).find('.js-product-card-variant').data('product-backorder')})`)

      //Add to cart if there are no variant options OR product is broken out by variant with only one option (therefore rendering no quick add options)
      if ((optionTypes.length === 1 && optionTypes[0] === 'Title') || (optionTypes.length === 1 && el.classList.contains('variant-breakout'))) { // Takes care of CLP products broken out by variant

        let variantId 

        if ((optionTypes.length === 1 && optionTypes[0] === 'Title')) {
          //For only 1 variant - variant ID is attached to only option
          variantId = $(el).find(`option`)[0].value
        } else {
          //For broken out variants - finds variant ID based on which variant is displayed
          let variantDisplayed = el.querySelector('select').dataset.productVariantDisplayed
          variantId = $(el).find(`option[data-variant-name="${variantDisplayed}"]`)[0].value
        }

        if(variantAvailabilityObj[variantId].soldout === "true" || variantAvailabilityObj[variantId].available === "false") {
          $(el).find('.qa-add-to-cart p').text('sold out')
          $(el).find('.snowe-button-global').addClass('sold-out').off('click')
        }

        if(variantAvailabilityObj[variantId].preorder === "true") {
          //update preorder date
          $(el).find('.js_quick-add_backorder-info').addClass('x').find('p').text(`(Preorder for ${variantAvailabilityObj[variantId].backorder})`)
        }
                
        if($(el).find('.js_quick-add_product-info .snowe-button-global').hasClass('hide')){ 
          $(el).find('.js_quick-add_product-info .coll-product-name').css('min-height', '42px')
          $(el).find('.js_quick-add_product-info .snowe-button-global').parent().removeClass('hide')
          $(el).find('.js_quick-add_product-info .snowe-button-global').removeClass('hide').click(()=>{
            CLPAddToCart(variantId, errorHandler, null, closeCLP)
            standard.showSidePanel();
            return false
          })
        } 
      }
      else if (optionTypes.length >= 1) { // Takes care of CLP products with variants 
      
         optionTypes.forEach((optionType, i) => { // (i.e. Color, Size, Density, Finish, Material, Scent)
          if(!(el.classList.contains('variant-breakout') && optionType == $(el).find('.js-product-card-variant').data('breakout-option'))){

            let brokenOut = $(el).find(`.js-product-card-variant`).data('breakout-option') ? true : false
            

            let variantBreakoutOption = brokenOut ? $(el).find(`.js-product-card-variant`).data('breakout-option') : null
            let breakoutOptionIdx = brokenOut ? indexOf(optionTypes, variantBreakoutOption) : null
            let breakoutOptionValue = brokenOut ? $(el).find('.js-product-card-variant').data('product-variant-displayed').split(" / ")[breakoutOptionIdx] : null

            //Defines function that checks variantAvailabilityObj for the potential variant and adds "sold-out" class to class list to prevent variant from being selected and added to the quick-add cart
            const variantAvailabilityChecker = (variant, option) => {
              if(variantAvailabilityObj[variant.id].waitlist === "true") {
                option.classList.add('sold-out')
              }

              if(variantAvailabilityObj[variant.id].soldout === "true") {
                option.classList.add('sold-out')
              }

              if(variantAvailabilityObj[variant.id].preorder === "true") {
                option.classList.add('preorder')
                option.dataset.preorderDate = variantAvailabilityObj[variant.id].backorder
              }
            }

            switch (optionType) {
              case 'Density':
                let densityContent = buildOptions(variants, optionTypes, i)  // builds options for this option type
                densityContainer.innerHTML = densityContent // injects options html into DOM
                densityContainer.classList.add('has-options')
                container = densityContainer
                densitySecondOption = optionTypes.length > 1 ? optionTypes.find(optionType => optionType != 'Density') : null // sets reference to second option (i.e. Size if this option is Density)

                options = container.querySelectorAll('.js-variant-selector') // Density options we injected in the DOM
                options.forEach((option,idx) => {
                  setOnClickAndHover(container, option, idx, optionType)

                  if (brokenOut) {
                    //finds correct variant in variants
                    let variant = variants.find( variant => variant.title.includes(option.dataset.variantOption) && variant.title.includes(breakoutOptionValue)) //finds correct variant in variants
                    
                    //check if variant is unavailable and set to "sold-out"
                    variantAvailabilityChecker(variant, option)
                  }
                 
                }) //for each DOM option, runs all functions to set quick add features
              break
              case 'Size':
                let sizeContent = buildOptions(variants, optionTypes, i) // builds options for this option type
                sizeContainer.innerHTML = sizeContent // injects options html into DOM
                sizeContainer.classList.add('has-options')
                container = sizeContainer
                sizeSecondOption = optionTypes.length > 1 ? optionTypes.find(optionType => optionType != 'Size') : null // sets reference to second option (i.e. Size if this option is size)
                sizeSecondOption = el.classList.contains('variant-breakout') ? null : sizeSecondOption 
                options = container.querySelectorAll('.js-variant-selector') // Size options we injected in the DOM
                options.forEach((option,idx) => {
                  setOnClickAndHover(container, option, idx, optionType)

                  if (brokenOut) {
                    //finds correct variant in variants (handles choosing correct size - ie 'small' instead of defaulting to 'x-small')
                    let variant  = variants.find( variant => 
                      variant.option1 === option.dataset.variantOption && variant.title.includes(breakoutOptionValue) || variant.option2 === option.dataset.variantOption && variant.title.includes(breakoutOptionValue)
                    )
                    
                    //check if variant is unavailable and set to "sold-out"
                    variantAvailabilityChecker(variant, option)
                  }

                }) //for each DOM option, runs all functions to set quick add features

              break
              case 'Color':
                let colorContent = buildOptions(variants, optionTypes, i)
                colorContainer.innerHTML = colorContent
                colorContainer.classList.add('has-options')
                container = colorContainer
                colorSecondOption = optionTypes.length > 1 ? optionTypes.find(optionType => optionType != 'Color') : null
                options = container.querySelectorAll('.js-variant-selector')
                options.forEach((option,idx) => {
                  setOnClickAndHover(container, option, idx, optionType)

                  if (brokenOut) {

                    //finds correct variant in variants
                    let variant = variants.find( variant => variant.title.includes(option.dataset.variantOption) && variant.title.includes(breakoutOptionValue)) //finds correct variant in variants
                    
                    //check if variant is unavailable and set to "sold-out"
                    variantAvailabilityChecker(variant, option)
                  }
                })

              break
              case 'Finish':
                let finishContent = buildOptions(variants, optionTypes, i)
                finishContainer.innerHTML = finishContent
                finishContainer.classList.add('has-options')
                container = finishContainer
                finishSecondOption = optionTypes.length > 1 ? optionTypes.find(optionType => optionType != 'Finish') : null
                options = container.querySelectorAll('.js-variant-selector')  
                options.forEach((option,idx) => {
                  setOnClickAndHover(container, option, idx, optionType)
                
                  if (brokenOut) {
                    //finds correct variant in variants
                    let variant = variants.find( variant => variant.title.includes(option.dataset.variantOption) && variant.title.includes(breakoutOptionValue)) //finds correct variant in variants
                    
                    //check if variant is unavailable and set to "sold-out"
                    variantAvailabilityChecker(variant, option)
                  }
                })
              break 
              case 'Material':
                let materialContent = buildOptions(variants, optionTypes, i)
                materialContainer.innerHTML = materialContent
                materialContainer.classList.add('has-options')
                container = materialContainer
                materialSecondOption = optionTypes.length > 1 ? optionTypes.find(optionType => optionType != 'Material') : null     

                options = container.querySelectorAll('.js-variant-selector')
                options.forEach((option,idx) => {
                  setOnClickAndHover(container, option, idx, optionType)

                  if (brokenOut) {
                    //finds correct variant in variants
                    let variant = variants.find( variant => variant.title.includes(option.dataset.variantOption) && variant.title.includes(breakoutOptionValue)) //finds correct variant in variants
                    
                    //check if variant is unavailable and set to "sold-out"
                    variantAvailabilityChecker(variant, option)
                  }

                })
              break
              case 'Scent':
                let scentContent = buildOptions(variants, optionTypes, i)
                scentContainer.innerHTML = scentContent
                scentContainer.classList.add('has-options')
                container = scentContainer
                scentSecondOption = optionTypes.length > 1 ? optionTypes.find(optionType => optionType != 'Scent') : null                

                options = container.querySelectorAll('.js-variant-selector')
                options.forEach((option,idx) => {
                  setOnClickAndHover(scentContainer, option, idx,  optionType)

                  if (brokenOut) {
                    //finds correct variant in variants
                    let variant = variants.find( variant => variant.title.includes(option.dataset.variantOption) && variant.title.includes(breakoutOptionValue)) //finds correct variant in variants
                    
                    //check if variant is unavailable and set to "sold-out"
                    variantAvailabilityChecker(variant, option)
                  }
                })
              break
            }
          }
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/collection-product-card.js